import { useDialog } from '@/ui-plus/dialog/use-dialog';
import IdVerificationForm from '@iframe-widgets/pages/widgets/dialogs/id-verification/IdVerificationForm.vue';
import { toast } from '@/ui-plus/sonner';

const dialog = useDialog();

export function showIdVerificationForm() {
    return new Promise((resolve) => {
        dialog.show({
            title: '',
            closeable: false,
            component: IdVerificationForm,
            onSuccess: () => {
                resolve(1);
            },
            onError: (message: string) => {
                console.error(message);
                toast.error(message);
                resolve(-1);
            },
            onCancel: () => {
                resolve(-1);
            }
        })
    })
}
